const FindValueByAttributeCode = (attributes) => {
    if(attributes.attributeCode == 'price'){
        console.log('property_description', attributes.attributeCode, attributes.attributes);
    }
    if(attributes && attributes.attributes && attributes.attributes.length > 0 && attributes.attributeCode){
        // 
        const attributeObject = attributes.attributes.find(
            (attribute) => attribute.code === attributes.attributeCode
        );
        // console.log(attributes.attributeCode, attributeObject)
        return attributeObject && attributeObject.value ? attributeObject.value : null;
    } else {
        return null;
    }
}
export default FindValueByAttributeCode;